import { isWeb, isAndroid, isIOS, isMobile } from "./platforms.constant";

export default {
  data() {
    // we don't use the '$_' prefix because we want those variables to be automatically published in templates
    return {
      get isWeb() {
        return isWeb;
      },
      get isAndroid() {
        return isAndroid;
      },
      get isIOS() {
        return isIOS;
      },
      get isMobile() {
        return isMobile;
      },
    };
  },
};
